define([
    'text!edge/quoteandbind/pa/views/pa-contact-details.html',
    'text!edge/quoteandbind/common/views/prequal-questions.html',
    'text!customerEdge/quoteandbind/common/views/membership.html',
    'text!customerEdge/quoteandbind/pa/views/driver-vehicle-prefilled-info.html',
    'text!customerEdge/quoteandbind/pa/views/prev-carrier-info.html',
    'text!edge/quoteandbind/pa/views/pa-driver-details.html',
    'text!edge/quoteandbind/pa/views/pa-vehicle-details.html',
    'text!edge/quoteandbind/pa/views/pa-policy-info.html',
    'text!customerEdge/quoteandbind/pa/views/pa-policy-summary.html',
    'text!edge/quoteandbind/common/views/requote-details.html',
    'text!customerEdge/quoteandbind/pa/views/pa-esignature.html',

    'edge/quoteandbind/pa/controllers/PAContactDetailsCtrl',
    'edge/quoteandbind/pa/controllers/PAPrequalQuestionsCtrl',
    'customerEdge/quoteandbind/common/controllers/MembershipCtrl',
    'customerEdge/quoteandbind/pa/controllers/DriverVehiclePrefilledInfoCtrl',
    'customerEdge/quoteandbind/pa/controllers/PrevCarrierInfoCtrl',
    'edge/quoteandbind/pa/controllers/PADriverDetailsCtrl',
    'edge/quoteandbind/pa/controllers/PAVehicleDetailsCtrl',
    'edge/quoteandbind/pa/controllers/PAPolicyInfoCtrl',
    'customerEdge/quoteandbind/pa/controllers/PAPolicySummaryCtrl',
    'edge/quoteandbind/common/controllers/ReQuoteDetailsCtrl',
    'customerEdge/quoteandbind/pa/controllers/PAESignatureCtrl'
], (PAContactDetailsView, PAPreQualQuestionsView, PAMembershipView, PADriverVehiclePrefilledView, PAPrevCarrierInfoView, DriverDetailsView, VehicleDetailsView, PolicyInfoView, PolicySummaryView,ReQuoteDetailsView, PAESignatureView,
    PAContactDetailsCtrl, PAPreQualQuestionsCtrl, MembershipCtrl, DriverVehiclePrefilledCtrl,  PrevCarrierInfoCtrl, DriverDetailsCtrl, VehicleDetailsCtrl, PolicyInfoCtrl, PolicySummaryCtrl,ReQuoteDetailsCtrl, PAESignatureCtrl)=> {
    return () => {
        const wizardParentState = 'baseQnbWizard';

        return {
            paContactDetails: {
                parent: wizardParentState,
                template: PAContactDetailsView,
                controller: PAContactDetailsCtrl
            },
            paPrequalQuestions: {
                parent: wizardParentState,
                controller: PAPreQualQuestionsCtrl,
                template: PAPreQualQuestionsView
            },
            paMembership: {
                parent: wizardParentState,
                template: PAMembershipView,
                controller: MembershipCtrl
            },

            paDriverVehiclePrefillInfo: {
                parent: wizardParentState,
                template: PADriverVehiclePrefilledView,
                controller: DriverVehiclePrefilledCtrl
            },
            paPrevCarrierInfo: {
                parent: wizardParentState,
                template: PAPrevCarrierInfoView,
                controller: PrevCarrierInfoCtrl
            },
            paDriverDetails: {
                parent: wizardParentState,
                controller: DriverDetailsCtrl,
                template: DriverDetailsView
            },
            paVehicleDetails: {
                parent: wizardParentState,
                controller: VehicleDetailsCtrl,
                template: VehicleDetailsView,
                resolve: {
                    availableYears: ['$q', 'VinLookupService', 'submissionViewModel', 'ModalService', ($q, VinLookupService, submissionViewModel, ModalService) => {

                        const submissionVm = new submissionViewModel();
                        var vinDetails = {};
                        vinDetails.searchType = "AvailableYears";
                        vinDetails.vinServiceSearchType = angular.copy(vinDetails.searchType);
                        vinDetails.quoteID = submissionVm.quoteID.value;
                        vinDetails.masterMakeList = {};
                        vinDetails.vehicleType = "auto";
                        
                        var msgBox = ModalService.showLoadingDialog('quoteandbind.views.modal.Please wait');

                        var deferred = $q.defer();
                        VinLookupService.aaaVINLookup('quoteandbind', vinDetails).then(
                            function(response){
                                msgBox.close();
                                deferred.resolve(response);
                            },
                            function(error){
                                msgBox.close();
                                deferred.resolve({});
                            }
                        );
                
                        return deferred.promise;
                    }]
                }
            },


            paRequoteDetails: {
                //name: 'requoteDetails',
                parent: wizardParentState,
                controller: ReQuoteDetailsCtrl,
                template: ReQuoteDetailsView
            },

            paPolicyInfo: {
                parent: wizardParentState,
                controller: PolicyInfoCtrl,
                template: PolicyInfoView
            },
            paPolicySummary: {
                parent: wizardParentState,
                controller: PolicySummaryCtrl,
                template: PolicySummaryView
            },
            paEsignature: {
                parent: wizardParentState,
                controller: PAESignatureCtrl,
                template: PAESignatureView
            }
        };
    };
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/pa/config/RouteConfig.js
 **/